import { LogLevel } from "./index.js";

export function printLog(
  level: LogLevel,
  ...consoleArgs: Parameters<Console["log"]>
) {
  const now = new Date();
  const callerInfo = getCallerInfo();
  const timestamp = now.toLocaleString();

  const colorStyles: { [key in LogLevel]: string } = {
    debug: "color: gray;",
    error: "color: red;",
    info: "color: #7c93e6;",
    warn: "color: orange;",
  };
  const levelStr = level.toUpperCase();

  console[level](
    `%c${levelStr}%c [${timestamp}] [${callerInfo}]:\n`,
    colorStyles[level],
    "color: default;",
    ...consoleArgs,
  );
}

function getCallerInfo() {
  try {
    const error = new Error();
    const stack = error.stack?.split("\n");
    if (stack && stack.length > 4) {
      const callerStackLine = stack[4];
      const match =
        callerStackLine.match(/at\s+(.*)\s+\((.*):(\d+):(\d+)\)/) ||
        callerStackLine.match(/at\s+(.*):(\d+):(\d+)/);

      if (match) {
        return match[1].trim();
      }
    }
  } catch (e) {
    console.error("Error getting caller info", e);
  }
  return "unknown";
}
